import logger from "logging/logger";
import { ref, remove, update } from "firebase/database";
import { database } from "../../services/firebaseService/firebaseConfig";

const SPACE_PATH = "/Space";
const USER_STATUS_PATH = "UserStatus";

export const removeUserFromSpace = (
  spaceId: string,
  userId: string,
  roomId: string,
) => {
  logger.info(
    `[removeUserFromSpace] remove user-${userId} from space-${spaceId} in room-${roomId}`,
  );

  return Promise.all([
    remove(ref(database, `${SPACE_PATH}/${spaceId}/UserStatus/${userId}`)),
    remove(
      ref(
        database,
        `${SPACE_PATH}/${spaceId}/UserRoomStatus/${roomId}/${userId}`,
      ),
    ),
  ]);
};

export const updateUserStatus = (
  spaceId: string,
  userId: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any,
) =>
  update(ref(database, `${SPACE_PATH}/${spaceId}/UserStatus/${userId}`), {
    ...data,
    lastUpdatedAt: new Date().getTime(),
  });

// TODO: Refactor
export const getSpaceUserStatusRef = (spaceId: string) =>
  ref(database, `${SPACE_PATH}${spaceId}/${USER_STATUS_PATH}`);
